import React, { useState, useEffect } from "react";
import {
    EuiPopover,
    EuiHeaderSectionItemButton,
    EuiKeyPadMenuItem,
    EuiIcon,
    EuiSwitch,
    EuiHeaderSection,
} from "@elastic/eui";
import { htmlIdGenerator } from "@elastic/eui/lib/services";
// import Logout from '../logout'
import { useDispatch } from "react-redux";
import * as S from "./style";

/**
 * This component is setting local storage to null and redirect to login
 */

import { logout } from "../../../auth/slice";

function HeaderAppMenu() {
    const idGenerator = htmlIdGenerator();
    const popoverId = idGenerator("popover");
    const keypadId = idGenerator("keypad");

    const [isOpen, setIsOpen] = useState(false);
    const lang = localStorage.getItem("locale");
    const theme = localStorage.getItem("theme");

    const getThemeText = (isDark) => (isDark ? "dark" : "light");
    const [locale, setLocale] = useState(lang || "en");
    const dispatch = useDispatch();
    const [isDarkTheme, setIsDarkTheme] = useState(theme === "dark");

    useEffect(() => {
        if (getThemeText(isDarkTheme) !== theme) {
            localStorage.setItem("theme", getThemeText(isDarkTheme));
            window.location.reload();
        }
    }, [isDarkTheme]);

    useEffect(() => {
        if (locale !== lang) {
            localStorage.setItem("locale", locale);
            window.location.reload();
        }
    }, [locale]);

    const onMenuButtonClick = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };
    const toggleTheme = (flag) => {
        setIsDarkTheme(flag);
    };
    const renderLogout = () => {
        const isAuthenticated =
            localStorage.getItem("accessToken") !== null &&
            localStorage.getItem("accessToken") !== "null";
        return (
            isAuthenticated && (
                <EuiKeyPadMenuItem
                    label="Logout"
                    onClick={() => {
                        dispatch(logout());
                    }}
                >
                    <EuiIcon
                        type="exit"
                        size="l"
                    />
                </EuiKeyPadMenuItem>
            )
        );
    };
    const onLocaleChange = (value) => {
        setLocale(value);
    };
    const button = (
        <EuiHeaderSectionItemButton
            aria-controls={keypadId}
            aria-expanded={isOpen}
            aria-haspopup="true"
            aria-label="Apps menu with 1 new app"
            onClick={onMenuButtonClick}
        >
            <EuiIcon
                type="apps"
                size="m"
            />
        </EuiHeaderSectionItemButton>
    );

    return (
        <EuiPopover
            id={popoverId}
            button={button}
            isOpen={isOpen}
            anchorPosition="downRight"
            closePopover={closeMenu}
        >
            <S.StyledPadMenu
                id={keypadId}
                className="burger-menu"
            >
                <EuiKeyPadMenuItem
                    label={locale == "en" ? "عربى" : "English"}
                    onClick={() => onLocaleChange(locale == "en" ? "ar" : "en")}
                >
                    {/* <EuiIcon type="dashboardApp" size="l" /> */}

                    <i
                        className={`icon 
                            ${locale == "en" ? "icon-en-to-ar" : "icon-ar-to-en"}
                        `}
                    />
                </EuiKeyPadMenuItem>

                <EuiHeaderSection>{renderLogout()}</EuiHeaderSection>
                <EuiKeyPadMenuItem label="Dark mode">
                    <EuiSwitch
                        checked={isDarkTheme}
                        onChange={(e) => toggleTheme(e.target.checked)}
                        compressed
                    />
                </EuiKeyPadMenuItem>
            </S.StyledPadMenu>
        </EuiPopover>
    );
}

export default HeaderAppMenu;
